<template>
<div class="Industry">
    <div class="title">{{indata.FirstTitle}}</div>
    <h6>{{indata.subTitle}}</h6>
    <div class="icon_group" style="margin-bottom:40px">
    	<span class="icon01" style="margin-left:90px;" v-for="(item, index) in indata.children":key="index" >
     <img :src="item.image" alt="" />
            <h5>{{item.introduce}}</h5>
        </span>
    </div>
    </div>
    
</template>
<style scoped src="../../public/css/icould.css">
</style>

<script>
export default {
  name: "Templates25",
  props:{
    indata:Array
  },
  data(){
    return{
      NowIndex:0
    }
  }
  ,
  methods :{
changeActive(index){
  this.NowIndex=index
}
  }
};
</script>
